<template>
<div class="copy-colors">
  <div class="colors-list">
    <div>
      <div>复制颜色</div>
      <div style="color: var(--footer-color);font-size: .7em">点击行内空白处复制整行数据<br/>点击单个数值以复制单个数据</div>
    </div>
    <div style="display: flex;flex-direction: row;justify-content: flex-end;align-items: flex-end;gap: .5em;flex-grow: 1">
      <div>
        <div class="color-preview" style="width: 100%;border: 2px solid var(--primary-color)">
          <div class="color-preview__color" :style="{backgroundColor:`${showA?colors.hex8:colors.hex}`}"></div>
          <div class="color-preview__background"></div>
        </div>
        <div :style="{color:`${showA?colors.hex8:colors.hex}`}" style="font-size: .7em">颜色预览</div>
      </div>
      <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;gap: .5em">
        <van-switch v-model="showA" size="18" />
        <div style="font-size: .7em;" :style="{color: `var(--${showA?'primary':'text'}-color)`}">应用透明度</div>
      </div>
    </div>
  </div>
  <div class="colors-list" @click="copyText(`HEX${showA?'8':''}`,'VALUE',showA?colors.hex8:colors.hex)">
    <div>Hex{{showA?'8':''}}</div>
    <div class="color-item">
      <div>{{showA?colors.hex8:colors.hex}}</div></div>
  </div>
  <div class="colors-list" @click="copyText(`RGB${showA?'A':''}`,'VALUE',formatRGBA(colors.rgba))">
    <div>RGB{{showA?'A':''}}</div>
    <div class="color-item">
      <div class="color-item-group">
        <div class="color-item-value" @click.stop="copyText(`RGB${showA?'A':''}`,'R',colors.rgba.r)">{{ colors.rgba.r }}</div>
        <div class="color-item-name">R</div>
      </div>
      <div class="color-item-group">
        <div class="color-item-value"  @click.stop="copyText(`RGB${showA?'A':''}`,'G',colors.rgba.g)">{{ colors.rgba.g }}</div>
        <div class="color-item-name">G</div>
      </div>
      <div class="color-item-group">
        <div class="color-item-value"  @click.stop="copyText(`RGB${showA?'A':''}`,'B',colors.rgba.b)">{{ colors.rgba.b }}</div>
        <div class="color-item-name">B</div>
      </div>
      <div v-if="showA" class="color-item-group">
        <div class="color-item-value"  @click.stop="copyText(`RGBA`,'A',colors.rgba.a)">{{ colors.rgba.a }}</div>
        <div class="color-item-name">A</div>
      </div>
    </div>
  </div>
  <div class="colors-list" @click="copyText(`HSL${showA?'A':''}`,'VALUE',formatHSLVA(colors.hsl))">
    <div>HSL{{showA?'A':''}}</div>
    <div class="color-item">
      <div class="color-item-group">
        <div class="color-item-value" @click.stop="copyText(`HSL${showA?'A':''}`,'H',colors.hsl.h.toFixed(0)+'°')">{{ colors.hsl.h.toFixed(0)+'°' }}</div>
        <div class="color-item-name">H</div>
      </div>
      <div class="color-item-group">
        <div class="color-item-value" @click.stop="copyText(`HSL${showA?'A':''}`,'S',(colors.hsl.s*100).toFixed(0)+'%')">{{ (colors.hsl.s*100).toFixed(0)+'%' }}</div>
        <div class="color-item-name">S</div>
      </div>
      <div class="color-item-group">
        <div class="color-item-value" @click.stop="copyText(`HSL${showA?'A':''}`,'L',(colors.hsl.l*100).toFixed(0)+'%')">{{ (colors.hsl.l*100).toFixed(0)+'%' }}</div>
        <div class="color-item-name">L</div>
      </div>
      <div v-if="showA" class="color-item-group">
        <div class="color-item-value" @click.stop="copyText(`HSLA`,'A',colors.hsl.a)">{{ colors.hsl.a }}</div>
        <div class="color-item-name">A</div>
      </div>
    </div>
  </div>
  <div class="colors-list" @click="copyText(`HSV${showA?'A':''}`,'VALUE',formatHSLVA(colors.hsv,'v'))">
    <div>HSV{{showA?'A':''}}</div>
    <div class="color-item">
      <div class="color-item-group">
        <div class="color-item-value" @click.stop="copyText(`HSV${showA?'A':''}`,'H',colors.hsv.h.toFixed(0)+'°')">{{ colors.hsv.h.toFixed(0)+'°' }}</div>
        <div class="color-item-name">H</div>
      </div>
      <div class="color-item-group">
        <div class="color-item-value" @click.stop="copyText(`HSV${showA?'A':''}`,'S',(colors.hsv.s*100).toFixed(0)+'%')">{{ (colors.hsv.s*100).toFixed(0)+'%' }}</div>
        <div class="color-item-name">S</div>
      </div>
      <div class="color-item-group">
        <div class="color-item-value" @click.stop="copyText(`HSV${showA?'A':''}`,'V',(colors.hsv.v*100).toFixed(0)+'%')">{{ (colors.hsv.v*100).toFixed(0)+'%' }}</div>
        <div class="color-item-name">L</div>
      </div>
      <div v-if="showA" class="color-item-group">
        <div class="color-item-value" @click.stop="copyText(`HSVA`,'A',colors.hsv.a)">{{ colors.hsv.a }}</div>
        <div class="color-item-name">A</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import CommonFunction from "@/utils/CommonFunction";

export default {
  name: "CopyColor",
  computed: {
    CommonFunction() {
      return CommonFunction
    },
  },
  props:{
    colors: {
      type: Object,
      required: true,
    }
  },
  data() {
    return{
      showA: true,
      colorsList: [],
    }
  },methods:{
    copyText(prefixHeader,header, value) {
      this.$CF.copyText(value,`${prefixHeader}颜色值\n${header}：${value}\n`)
    },
    formatHSLVA(hs,last='l') {
      return hs.h.toFixed(0) + '°,'+(hs.s * 100).toFixed(0) + '%,' + (hs[last] * 100).toFixed(0) + '%' + (this.showA ? ',' + hs.a : '');
    },
    formatRGBA(rgba) {
      return `${rgba.r},${rgba.r},${rgba.r}${this.showA?`,${rgba.a}`:''}`
    },
  }
}
</script>

<style scoped>
.copy-colors {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.colors-list {
  width: 100%;
  padding: .5em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.colors-list:not(:last-child) {
  border-bottom: 1px solid var(--border-color);

}
.color-item{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: .5em;
}
.color-item-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: .3em;
}
.color-item-name {
  font-size: .7em;
  font-weight: 600;
}
.color-item-value {
  border: 1px solid var(--primary-color);
  border-radius: .2em;
  padding: 0 .3em;
  height: 1.5em;
  aspect-ratio: 2/1;
  text-align: center;
}
.color-preview {
  width: inherit;
  aspect-ratio: 1/1;
  border-radius: .5em;
  position: relative;
  overflow: hidden;

}
.color-preview__color{
  width: inherit;
  aspect-ratio: 1/1;
  transition: background-color .3s;
}
.color-preview__background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  background-color: #FFFFFF !important;
  background-image:      linear-gradient(45deg, #e0e0e0 25%, transparent 25%),
  linear-gradient(-45deg, #e0e0e0 25%, transparent 25%),
  linear-gradient(45deg, transparent 75%, #e0e0e0 75%),
  linear-gradient(-45deg, transparent 75%, #e0e0e0 75%);
  background-size: 10px 10px;
  background-position: 0 0, 0 5px, 5px -5px, -5px 0;

}
</style>
